'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterBarProps {
  selectedRegion: string;
  selectedIndustry: string;
  onRegionChange: (region: string) => void;
  onIndustryChange: (industry: string) => void;
  className?: string;
}

const FilterBar: React.FC<FilterBarProps> = ({
  selectedRegion,
  selectedIndustry,
  onRegionChange,
  onIndustryChange,
  className = '',
}) => {
  const regions = ['All Regions', 'India', 'UAE'];
  const industries = [
    'All Industries',
    'Agriculture',
    'Manufacturing',
    'Real Estate',
    'Technology',
    'Hospitality',
  ];

  return (
    <div className={`bg-card border border-border rounded-lg p-4 md:p-6 ${className}`}>
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <label className="block text-sm font-medium text-text-primary mb-2">
            Filter by Region
          </label>
          <div className="relative">
            <select
              value={selectedRegion}
              onChange={(e) => onRegionChange(e.target.value)}
              className="w-full px-4 py-2.5 pr-10 bg-background border border-input rounded-lg text-text-primary appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-200"
            >
              {regions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
            <Icon
              name="ChevronDownIcon"
              size={20}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary pointer-events-none"
            />
          </div>
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium text-text-primary mb-2">
            Filter by Industry
          </label>
          <div className="relative">
            <select
              value={selectedIndustry}
              onChange={(e) => onIndustryChange(e.target.value)}
              className="w-full px-4 py-2.5 pr-10 bg-background border border-input rounded-lg text-text-primary appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-200"
            >
              {industries.map((industry) => (
                <option key={industry} value={industry}>
                  {industry}
                </option>
              ))}
            </select>
            <Icon
              name="ChevronDownIcon"
              size={20}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary pointer-events-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;